import { isPlatformBrowser, NgFor, NgIf } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import dayjs from 'dayjs';
import { TsHttpService } from '../../services/ts-http.service';
import { RssFeedItem, TvScreenService } from '../../services/tv-screen.service';
import { TvSlideService } from '../../services/tv-slide.service';

@Component({
  selector: 'ts-infosystem-rss',
  templateUrl: './infosystem-rss.component.html',
  styleUrls: ['./infosystem-rss.component.css'],
  imports: [NgFor, NgIf],
})
export class InfosystemRssComponent implements OnInit, OnDestroy {
  @Input() schoolId: number;
  rss: RssFeedItem[] = [];
  rssIndex = 0;
  readonly currentYear = new Date().getFullYear();
  private slideInterval?: ReturnType<typeof setInterval>;

  constructor(
    private tvScreenSrv: TvScreenService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    // Feed comes from the shared poll; keep last-good (don't blank on an empty
    // emission) and keep rssIndex in range when the set shrinks.
    this.tvScreenSrv.payload$.pipe(takeUntilDestroyed()).subscribe((payload) => {
      const items = payload?.rss ?? [];
      if (items.length) {
        this.rss = items;
        if (this.rssIndex >= this.rss.length) {
          this.rssIndex = 0;
        }
      }
    });
  }

  formatDate(date: string): string {
    return dayjs(date).format('DD.MM. HH:mm');
  }

  getRssImgUrl(index: number): string {
    const imageUrl = this.rss?.[index]?.imageUrl;
    // The BFF returns a relative image path; resolve it against the API root.
    return imageUrl ? `${TsHttpService.root}${imageUrl}` : '';
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.slideInterval = setInterval(() => {
        if (this.rss.length) {
          this.rssIndex = this.rssIndex < this.rss.length - 1 ? this.rssIndex + 1 : 0;
        }
      }, TvSlideService.slideDuration);
    }
  }

  ngOnDestroy(): void {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }
}
